var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-freeze-spinner",class:_vm.isCompLoader ? 'comp-loader' : ''},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"no-freeze-spinner"}},[_c('div',[_c('i',{staticClass:"fa fa-envelope"}),_c('i',{staticClass:"fa fa-list"}),_c('i',{staticClass:"fa fa-user-tie"}),_c('i',{staticClass:"fa fa-calculator"}),_c('div')])])
}]

export { render, staticRenderFns }